let pencil = require('./assets/image/icon/icon_pencil.svg')
let pencilWhite = require('./assets/image/icon/icon_pencil_white.svg')
let pen = require('./assets/image/icon/icon_pen.svg')
let penWhite = require('./assets/image/icon/icon_pen_white.svg')
let hat = require('./assets/image/icon/icon_hat.svg')
let hatWhite = require('./assets/image/icon/icon_hat_white.svg')
let award = require('./assets/image/icon/icon_award.svg')
let awardWhite = require('./assets/image/icon/icon_award_white.svg')
let backpack = require('./assets/image/icon/icon_backpack.svg')
let backpackWhite = require('./assets/image/icon/icon_backpack_white.svg')
let book = require('./assets/image/icon/icon_book.svg')
let bookWhite = require('./assets/image/icon/icon_book_white.svg')
let like = require('./assets/image/icon/icon_like.svg')
let likeWhite = require('./assets/image/icon/icon_like_white.svg')
let likeRed = require('./assets/image/icon/icon_like_red.svg')
let likePureWhite = require('./assets/image/icon/icon_like_pureWhite.svg')

let doc = require('./assets/image/icon/icon_document.svg')
let docWhite = require('./assets/image/icon/icon_document_white.svg')
let star = require('./assets/image/icon/icon_star.svg')
let starWhite = require('./assets/image/icon/icon_star_white.svg')
let starYellow = require('./assets/image/icon/icon_star_yellow.svg')

let iconEdit = require('./assets/image/icon/icon_edit.svg')
let iconTrash = require('./assets/image/icon/icon_trash.svg')

let iconArrow = require('./assets/image/icon/btn_right_arrow.svg')

let iconCheck = require('./assets/image/icon/icon_check_gray.svg')
let iconChecked = require('./assets/image/icon/icon_check_green.svg')

let iconPass = require('./assets/image/icon/icon_pass.svg')
let iconNoPass = require('./assets/image/icon/icon_pass_no.svg')

let iconFolder = require('./assets/image/icon/icon_folder.svg')
let iconAPlus = require('./assets/image/icon/icon_a_plus.svg')
let iconPointing = require('./assets/image/icon/icon_pointing.svg')
let iconPaperClip = require('./assets/image/icon/icon_paper_clip.svg')

let iconAnalytics = require('./assets/image/icon/icon_analytics.svg')

let iconExport = require('./assets/image/icon/icon_export.svg')

const icon = {
  'pencil': pencil,
  'pencilWhite': pencilWhite,
  'pen': pen,
  'penWhite': penWhite,
  'hat': hat,
  'hatWhite': hatWhite,
  'award': award,
  'awardWhite': awardWhite,
  'backpack': backpack,
  'backpackWhite': backpackWhite,
  'book': book,
  'bookWhite': bookWhite,
  'like': like,
  'likeWhite': likeWhite,
  'likeRed': likeRed,
  'likePureWhite': likePureWhite,
  'doc': doc,
  'docWhite': docWhite,
  'star': star,
  'starWhite': starWhite,
  'starYellow': starYellow,
  'edit': iconEdit,
  'trash': iconTrash,
  'rightArrow': iconArrow,
  'check': iconCheck,
  'checked': iconChecked,
  'pass': iconPass,
  'nopass': iconNoPass,
  'folder': iconFolder,
  'aPlus': iconAPlus,
  'pointing': iconPointing,
  'paperClip': iconPaperClip,
  'analytics': iconAnalytics,
  'export': iconExport
}

export default icon



// WEBPACK FOOTER //
// ./src/icon.js